.ItemErrorContainer
    border: 1px solid rgb($globalSettingsStrokeSecondary)
    background-color: rgb($globalErrorBackground) !important
    color: rgb($globalErrorFont)
    font-weight: 700
    border-radius: $globalSettingsRounding $globalSettingsRounding 0 0
    min-height: 0
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center
    margin: 10px 0 -20px
    padding: 20px 20px 30px
    font-size: 14px
    box-sizing: border-box
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    overflow: visible
    z-index: $indexItem

.ItemErrorCloseContainer
    width: 25px
    height: 25px
    display: flex
    align-items: center
    justify-content: center
    cursor: pointer
    &:hover
        color: rgb($globalSettingsBackgroundSecondary)

@media #{$tablet}
    .ItemErrorContainer
        max-width: 480px
